import React from 'react';
import PropTypes from 'prop-types';
import { Detail, DetailLabel, DetailLinkValue, DetailValue } from './style';

function SectionCell({
  black = false,
  label = '',
  link = null,
  linkLabel = '-',
  nowrap = false,
  size = '25%',
  value
}) {
  return (
    <Detail size={size}>
      <DetailLabel>{label}</DetailLabel>
      {link ? (
        <DetailLinkValue $black={black} href={link}>
          {linkLabel}
        </DetailLinkValue>
      ) : (
        <DetailValue $black={black} $nowrap={nowrap}>
          {value || '-'}
        </DetailValue>
      )}
    </Detail>
  );
}

SectionCell.propTypes = {
  black: PropTypes.bool,
  label: PropTypes.string,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  nowrap: PropTypes.bool,
  size: PropTypes.string,
  value: PropTypes.string
};

export default SectionCell;
